<template>
  <Toast position="top-right" />
</template>

<script setup lang="ts">
import Toast from 'primevue/toast';
</script>
